module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"GooleMapClickTip":"Select location by clicking the map or dragging the marker"},"zh":{"GooleMapClickTip":"点击地图或者拖拽图标选择地址"},"mm":{"GooleMapClickTip":"လိပ်စာကို ရွေးချယ်ရန် မြေပုံပေါ်တွင် နှိပ်ပါ သို့မဟုတ် အိုင်ကွန်ကို ဆွဲယူပါ။"}}')
  delete Component.options._Ctor
}
